import type { Vehicle } from '../../schema/row-types.ts';
import type {
  RowOrderBy,
  RowQuery,
  SqliteQueryOptions,
} from '../../types/query.ts';
import { vehicles } from '../../schema/tables/tides/vehicles.ts';
import { findRows } from '../sqlite-query.ts';

/**
 * Returns an array of all vehicles that match the query parameters.
 * @param query Column values to match, as single values or arrays
 * @param fields Columns to select, or every column when empty
 * @param orderBy Column and direction pairs to sort by
 * @param options Query options, including the database to read from
 * @returns Matching rows, containing only `fields` when it is not empty
 */
export function getVehicles<Fields extends keyof Vehicle>(
  query: RowQuery<Vehicle> = {},
  fields: readonly Fields[] = [],
  orderBy: RowOrderBy<Vehicle> = [],
  options: SqliteQueryOptions = {},
) {
  return findRows<Vehicle, Fields>(vehicles, query, fields, orderBy, options);
}
